<template>
  <div class="instructions-view">
    <KanbanInstructionsModal :isVisible="true" @close="handleClose" />
  </div>
</template>

<script setup lang="ts">
import KanbanInstructionsModal from '@/components/KanbanInstructionsModal.vue'

const handleClose = () => {
  // Reopen the modal immediately for continuous review
  setTimeout(() => {
    // The modal will stay visible due to :isVisible="true"
  }, 100)
}
</script>

<style scoped>
.instructions-view {
  min-height: 100vh;
  background-color: #f3f4f6;
}
</style>